import React from 'react'
import classes from '../../Table.module.scss'

export const Header = ({ children }: { children: React.ReactNode }) => (
  <div role='rowgroup' className={classes.headers}>
    {children}
  </div>
)
